import { BulkReachoutTemplateVersion } from "@shared/lib/types/pricingWorkload";
import { BULK_REACHOUT_TEMPLATE_HTML } from "./constants";
import type { BulkReachoutTemplateFormValues } from "./buildActionParams";

function escapeHtml(value: string) {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

export function renderBulkReachoutTemplateHtml(
  templateVersion: BulkReachoutTemplateVersion,
  values: Pick<
    BulkReachoutTemplateFormValues,
    "product" | "timeline" | "additionalMessage" | "separateDeliverables"
  >
): string {
  let html = BULK_REACHOUT_TEMPLATE_HTML[templateVersion];
  const product = values.product.trim();
  const timeline = values.timeline.trim();
  const additionalMessage = values.additionalMessage.trim();
  const separateDeliverables = values.separateDeliverables
    .map((item) => item.trim())
    .filter(Boolean);

  if (product) {
    html = html.replaceAll("{{product}}", escapeHtml(product));
  }

  if (timeline) {
    html = html.replaceAll("{{timeline}}", escapeHtml(timeline));
  }

  if (additionalMessage) {
    html = html.replaceAll("{{message}}", escapeHtml(additionalMessage));
  }

  if (separateDeliverables.length > 0) {
    html = html.replaceAll(
      "{{separateDeliverables}}",
      separateDeliverables.map((item) => escapeHtml(item)).join("<br />")
    );
  }

  return html;
}
